import { TrackData } from '@interco/track'
import { ErrorCodes, MarginErrorCodes, StepRefin } from '@utils/enums'

type EnvType = 'development' | 'staging' | 'production'

const ERRO_STEP_MARKERS = ['ERRO', 'DESQUALIFICACAO', 'INDISPONIVEL', 'BLOQUEADO', 'NAO_LIBERADO']

const isErroStepKey = (key: string): boolean =>
  ERRO_STEP_MARKERS.some((marker) => key.includes(marker))

const ERRO_VALUES = new Set<string>([
  ...Object.values(ErrorCodes ?? {}),
  ...Object.values(MarginErrorCodes ?? {}).filter((code) => code !== MarginErrorCodes?.SUCCESS),
  ...Object.entries(StepRefin)
    .filter(([key]) => isErroStepKey(key))
    .map(([, value]) => String(value)),
])

export const isErroStep = (step: StepRefin | string): boolean => ERRO_VALUES.has(String(step))

export const initTrackRefin = (sessionId: string, isApp: boolean) => {
  TrackData.initOrUpdate({
    runtimeEnv: process.env.REACT_APP_ENVIROMENT as EnvType,
    projectName: 'cp-refinanciamento-consignado-ui',
    allowLocalHost: true,
    commonData: {
      product: 'REFINANCIAMENTO',
      sessionId,
      isApp: String(isApp),
    },
  })
}

const ignoreTrackingNetworkFailure = () => undefined

export const logTrackRefinStep = (step: StepRefin | string, data?: Record<string, string>) => {
  const payload = { event: step, ...data }
  const request = isErroStep(step) ? TrackData.error(payload) : TrackData.log(payload)

  request.catch(ignoreTrackingNetworkFailure)
}
